import queryString from "query-string";
export const stringifyQuery = (query, encode = true) => queryString.stringify(query, {
  encode
});